"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CFontIcon = _interopRequireDefault(require("./CFontIcon.js"));

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n\n  font-size: 10px;\n\n  margin-right: 8px;\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n\n  border-radius: 2px;\n\n  background-color: white;\n  transition: box-shadow 0.2s ease;\n  box-shadow: inset 0 0 0 ", "\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CheckboxIndicator = function CheckboxIndicator(_ref) {
  var isChecked = _ref.isChecked;
  return _react.default.createElement(StyledCheckboxIndicator, {
    className: "checkbox",
    isChecked: isChecked
  }, _react.default.createElement(_CFontIcon.default, {
    className: "fas fa-check",
    color: "white"
  }));
};

CheckboxIndicator.propTypes = {
  isChecked: _propTypes.default.bool
};
CheckboxIndicator.defaultProps = {
  isChecked: false
};

var StyledCheckboxIndicator = _styledComponents.default.div.withConfig({
  displayName: "CheckboxIndicator__StyledCheckboxIndicator",
  componentId: "sc-6mx8kh-0"
})(_templateObject(), function (props) {
  return props.isChecked ? "8px" : "2px";
}, function (props) {
  return props.theme[props.isChecked ? "$blue" : "$gray-5"];
});

CheckboxIndicator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxIndicator",
  "props": {
    "isChecked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = CheckboxIndicator;
exports.default = _default;
CheckboxIndicator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxIndicator",
  "props": {
    "isChecked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};